document.addEventListener('DOMContentLoaded', function() {
  const popPages = document.querySelectorAll('.pop-page');

  popPages.forEach(function(popPage) {
    const triggerButton = popPage.querySelector('.pop-page__details--button');
    if (!triggerButton) return;

    triggerButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      const id = triggerButton.getAttribute('data-id');
      const content = document.querySelector(`#page-content-${id}`);
      const exitButton = document.querySelector(`#${id} [data-close-button]`);
      const video = content?.querySelector('video');

      initModal(id, popPage, exitButton, video);
    });
  });

  function initModal(id, popPage, exitButton, video) {
    // Show modal
    popPage.classList.remove('custom--is-inactive');
    popPage.classList.add('modal--is-active');
    document.body.classList.add('modal--is-open');

    // Handle video
    const handleVideoPlay = () => {
      if (!video) return;
      
      // Ensure video is ready to play
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video started playing
          })
          .catch(error => {
            // Autoplay was prevented - show fallback UI or mute
            video.muted = true;
            video.play().catch(e => console.log('Video play failed:', e));
          });
      }
    };

    // Try to play video after a small delay (helps with some browsers)
    const videoAttempt = setTimeout(handleVideoPlay, 300);

    function closeModal() {
      popPage.classList.add('custom--is-inactive');
      popPage.classList.remove('modal--is-active');
      document.body.classList.remove('modal--is-open');
      
      if (video) {
        clearTimeout(videoAttempt);
        video.pause();
        video.currentTime = 0;
      }
    }

    // Exit button
    if (exitButton) {
      exitButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    }

    // Click outside
    popPage.addEventListener('click', function(e) {
      if (e.target === popPage) {
        closeModal();
      }
    });

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popPage.classList.contains('modal--is-active')) {
        closeModal();
      }
    });
  }
});